import { MeasurementName } from '@quromedical/models';
import { calculateQuroScore } from '@quromedical/news';
import { getValue } from './internal';
import { interpret } from './interpreter';

const resolveEarlyWarningScore = (relative, windowVitals, params) => {
  const pulseRate = getValue(windowVitals[MeasurementName.HeartRate]);
  const respirationRate = getValue(windowVitals[MeasurementName.RespiratoryRate]);
  const temperature = getValue(windowVitals[MeasurementName.CoreTemperature]);
  const oxygenSaturation = getValue(windowVitals[MeasurementName.OxygenSaturation]);
  const systolicBloodPressure = getValue(windowVitals[MeasurementName.SystolicArterialBloodPressure]);
  const hasUndefined = pulseRate === undefined || respirationRate === undefined || temperature === undefined;

  if (hasUndefined) {
    return [];
  } // calculate new score may throw if out of bounces


  try {
    const score = calculateQuroScore({ ...params,
      pulseRate,
      respirationRate,
      temperature,
      oxygenSaturation,
      systolicBloodPressure
    });
    return [{
      ts: relative,
      type: MeasurementName.EarlyWarningScore,
      value: score.score.toString()
    }];
  } catch (error) {
    return [];
  }
};

const earlyWarningScoreConfig = {
  window: 10000,
  base: MeasurementName.HeartRate,
  resolve: resolveEarlyWarningScore
};
export const configurations = [earlyWarningScoreConfig];
export const calculateEarlyWarningScores = interpret(configurations);
//# sourceMappingURL=news.js.map